// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SpBK","newExpiryDate":"styles_newExpiryDate__1qlt_","footer":"styles_footer__3gE9s"};